<template>
<div  ref="topDiv">
    <!-- 步骤1.产品基本信息、2.产品情况说明、3.质量特色、保护要求、4.商标、农产品信息、5申报机构信息、6申报材料、7.完成 -->
        <el-steps :active="active"  align-center>
            <el-step v-for="(item,index) in verticalData" :key="index"  :title="item.label"></el-step>
        </el-steps>



    <div class="step_page">
      <el-form :inline="true" :model= "forme" ref="active0" class="demo-form-inline" :rules="rules">
          <!-- 步骤1.产品基本信息页面 -->
        <div v-if="active===0">

          <el-descriptions title="产品信息" border :column="2" :size="size" class="step_page_des" label-class-name="my-labeljf" content-class-name="my_content_border">
            <el-descriptions-item label="产品中文名称：">
              <el-form-item prop="name">
                <el-input v-model= "forme.name" placeholder="请输入中文名称" :disabled="applyId &&  isDraftNum != 0" @blur="changeInput"></el-input>
              </el-form-item>
            </el-descriptions-item>
            <el-descriptions-item label="产品中文名称(拼音)："><el-form-item prop="namePinyin">
              <el-input v-model= "forme.namePinyin" placeholder="请输入名称全拼"></el-input></el-form-item></el-descriptions-item>
            <el-descriptions-item label="产品英文名称(非必填)："><el-form-item >
              <el-input v-model= "forme.nameEnglish"
              placeholder="请输入产品英文名称"
              onkeyup="value=value.replace(/[^a-zA-Z\s]/g,'')"
              @blur="inputName = $event.target.value"
              ></el-input></el-form-item></el-descriptions-item>
          </el-descriptions>
          <el-descriptions title="" border :column="2" :size="size" class="step_page_des" label-class-name="my-labeljf" content-class-name="my_content_border">
            <el-descriptions-item label="产品类型：">
              <el-form-item prop="applyType1">
                <el-select v-model= "forme.applyType1" placeholder="请选择"   @change="handleSelectChange">
                  <el-option v-for= "item in applyType1Options" :key= "item.id" :label= "item.name" :value= "item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-descriptions-item>
         <el-descriptions-item label="产品类型二级：" v-if= "forme.applyType1>0&&forme.applyType1<5">
            <el-form-item prop="applyType2"  @change="handleSelectChange2">
                <el-select v-model= "forme.applyType2" placeholder="请选择" >
                  <el-option
                  v-for="item in applyType2Options"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                  </el-option>
              </el-select>
            </el-form-item>
        </el-descriptions-item>
              <el-descriptions-item label="产品类型三级：" v-if= "isShowApplyType3">
                    <el-form-item prop="applyType3">
                        <el-select v-model= "forme.applyType3" placeholder="请选择" >
                          <el-option
                          v-for="item in applyType3Options"
                          :key="item.id"
                          :label="item.name"
                          :value="item.id">
                          </el-option>
                      </el-select>
                  </el-form-item>
              </el-descriptions-item>
              <el-descriptions-item label="其他产品类别：" v-if= "forme.applyType1===5"><el-form-item prop="otherApplyType"><el-input v-model= "forme.otherApplyType" placeholder="请输入中文名称"></el-input></el-form-item></el-descriptions-item>
          </el-descriptions>
          <el-descriptions title="文件上传" border :column="1" :size="size" class="step_page_des" label-class-name="my-labeljf" content-class-name="my_content_border">
              <el-descriptions-item label="产品图片：" >
                  <el-form-item  ref="upload1" style="width: 100%" prop="otherCategories">
                  <el-upload
                    class="upload-container"
                    action="#"
                    :accept="acceptIMG"
                    ref="otherCategories"
                    :before-remove="beforeRemove"
                    :before-upload="beforeUploadIMG"
                    :on-change="(file, fileList) =>fileChange('otherCategories',file, fileList)"
                    :on-exceed="handleExceed"
                    :show-file-list="false"
                    :http-request="(file) => handleChangeFile('otherCategoriesUrl','otherCategories', file,'img')"
                    :limit = 1
                  >
                    <el-button size="small" type="primary">点击上传图片</el-button>
                    <el-input size="small" v-model= "forme.otherCategories" v-if="forme.otherCategories" style="width: 10rem"  disabled clearable></el-input>
                  </el-upload>



                  </el-form-item>
              </el-descriptions-item>
              <el-descriptions-item label="县级以上人民政府建议的地理标志产品保护范围："><el-form-item prop="originRange"><el-input type="textarea" rows="4" style="width:45rem" v-model= "forme.originRange" placeholder=""></el-input></el-form-item></el-descriptions-item>
              <el-descriptions-item label="产品描述："><el-form-item prop="description"><el-input type="textarea" rows="4" style="width:45rem" v-model= "forme.description" placeholder=""></el-input></el-form-item></el-descriptions-item>

          </el-descriptions>
        </div>
      </el-form>
      <el-form  :inline="true" :model= "forme" ref="active1" class="demo-form-inline" :rules="rules">
        <!-- 步骤2. 申报部门信息 -->
        <div v-if="active===1">
          <el-descriptions title="申报机构" border :column="2" :size="size" class="step_page_des" label-class-name="my-labeljf" content-class-name="my_content_border">
            <el-descriptions-item label="申报机构名称："><el-form-item prop="applyName">
              <el-input v-model= "forme.applyName"
              placeholder="请输入申报机构名称"></el-input></el-form-item></el-descriptions-item>
            <el-descriptions-item label="申报机构通信地址："><el-form-item prop="applyAddress">
              <el-input v-model= "forme.applyAddress" placeholder="请输入申报机构通信地址"></el-input></el-form-item></el-descriptions-item>
            <el-descriptions-item label="申报机构联系人："><el-form-item prop="applyContacts">
              <el-input v-model= "forme.applyContacts"
              placeholder="请输入申报机构联系人"
              ></el-input></el-form-item></el-descriptions-item>
            <el-descriptions-item label="申报机构电话："><el-form-item prop="applyPhone"><el-input v-model= "forme.applyPhone" placeholder="请输入申报机构电话"></el-input></el-form-item></el-descriptions-item>
            <el-descriptions-item label="申报机构传真："><el-form-item prop="applyFax"><el-input v-model= "forme.applyFax" placeholder="请输入申报机构传真"></el-input></el-form-item></el-descriptions-item>
            <el-descriptions-item label="申报机构电子邮箱："><el-form-item prop="applyEmail"><el-input v-model= "forme.applyEmail" placeholder="请输入申报机构电子邮箱"></el-input></el-form-item></el-descriptions-item>

          </el-descriptions>

          <el-descriptions title="产品所在地知识产权管理部门信息" border :column="2" :size="size" class="step_page_des" label-class-name="my-labeljf" content-class-name="my_content_border">
            <el-descriptions-item label="单位名称："><el-form-item prop="originName">
              <el-input v-model= "forme.originName"
              placeholder="请输入机构名称"></el-input></el-form-item></el-descriptions-item>
            <el-descriptions-item label="单位通信地址："><el-form-item prop="originAddress">
              <el-input v-model= "forme.originAddress"
              placeholder="请输入单位通信地址"

              ></el-input></el-form-item></el-descriptions-item>
            <el-descriptions-item label="单位联系人："><el-form-item prop="originContacts">
              <el-input v-model= "forme.originContacts"
              placeholder="请输入单位联系人"

              @blur="inputName = $event.target.value"
              ></el-input></el-form-item></el-descriptions-item>
            <el-descriptions-item label="单位联系电话："><el-form-item prop="originPhone"><el-input v-model= "forme.originPhone" placeholder="请输入单位联系电话"></el-input></el-form-item></el-descriptions-item>
            <el-descriptions-item label="单位联系传真："><el-form-item prop="originFax"><el-input v-model= "forme.originFax" placeholder="请输入单位联系传真"></el-input></el-form-item></el-descriptions-item>
            <el-descriptions-item label="单位电子邮箱："><el-form-item prop="originEmail"><el-input v-model= "forme.originEmail" placeholder="请输入单位电子邮箱"></el-input></el-form-item></el-descriptions-item>

          </el-descriptions>


        </div>
      </el-form>

      <el-form  :inline="true" :model= "forme" ref="active2" class="demo-form-inline" :rules="rules">
        <!-- 步骤3.申报材料 -->
        <div v-if="active===2">
              <el-descriptions title="申请材料必传文件" border :column="1" :size="size" class="step_page_des" label-class-name="my-labeljf" content-class-name="my_content_border">
                <el-descriptions-item label="地理标志产品保护申请书：">
                        <el-form-item prop="fileApply">
                            <el-upload
                            action="#"
                            ref="fileApply"
                            class="upload-container"
                            :accept="acceptPDF"
                            :before-upload="beforeUploadPDF"
                            :auto-upload="true"
                            :on-change="(file, fileList) =>fileChange('fileApply',file, fileList)"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :before-remove="beforeRemove"
                            :on-exceed="handleExceed"
                            :show-file-list="false"
                            limit=1

                            :file-list="fileList"
                            :http-request="(file) => handleChangeFile('fileApplyUrl','fileApply', file,'pdf')"

                            >
                            <el-button size="small" type="primary">点击上传PDF文件</el-button>
                              <el-input size="small" v-model= "forme.fileApply" v-if="forme.fileApply" style="width: 10rem"  disabled clearable></el-input>
                            </el-upload>
                    </el-form-item>
                </el-descriptions-item>

                      <el-descriptions-item label="县级以上人民政府界定保护范围的建议的文件：">
                        <el-form-item prop="fileAddress">
                            <el-upload
                            action="#"
                            ref="fileAddress"
                            class="upload-container"
                            :accept="acceptPDF"
                            :on-change="(file, fileList) =>fileChange('fileAddress',file, fileList)"
                            :before-upload="beforeUploadPDF"
                            :auto-upload="true"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :before-remove="beforeRemove"
                            :on-exceed="handleExceed"
                            :show-file-list="false"
                            :limit = 1
                            :file-list="iamgefile"
                            :http-request="(file) => handleChangeFile('fileAddressUrl','fileAddress', file,'pdf')"
                            >
                            <el-button size="small" type="primary">点击上传PDF文件</el-button>
                              <el-input size="small" v-model= "forme.fileAddress" v-if="forme.fileAddress" style="width: 10rem"  disabled clearable></el-input>
                            </el-upload>
                    </el-form-item>
                </el-descriptions-item>

                <el-descriptions-item label="县级以上人民政府申请保护文件：">
                        <el-form-item prop="fileApplyProtection">
                            <el-upload
                            action="#"
                            ref="fileApplyProtection"
                            class="upload-container"
                            :accept="acceptPDF"
                            :before-upload="beforeUploadPDF"
                            :auto-upload="true"
                            :on-change="(file, fileList) =>fileChange('fileApplyProtection',file, fileList)"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :before-remove="beforeRemove"
                            :on-exceed="handleExceed"
                            :show-file-list="false"
                            :limit = 1

                            :http-request="(file) => handleChangeFile('fileApplyProtectionUrl','fileApplyProtection', file,'pdf')"
                            >
                            <el-button size="small" type="primary">点击上传PDF文件</el-button>
                              <el-input size="small" v-model= "forme.fileApplyProtection" v-if="forme.fileApplyProtection" style="width: 10rem"  disabled clearable></el-input>
                            </el-upload>
                    </el-form-item>
                </el-descriptions-item>
                      <!-- TODO:字段对应不上 -->
                      <el-descriptions-item label="当地县级以上人民政府关于成立申报机构或指定协会、企业作为申请人的文件：">
                        <el-form-item prop="fileQualification">
                            <el-upload
                            action="#"
                            ref="fileQualification"
                            class="upload-container"
                            :accept="acceptPDF"
                            :on-change="(file, fileList) =>fileChange('fileQualification',file, fileList)"
                            :before-upload="beforeUploadPDF"
                            :auto-upload="true"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :before-remove="beforeRemove"
                            :on-exceed="handleExceed"
                            :show-file-list="false"
                            :limit = 1
                            :file-list="fileList"
                            :http-request="(file) => handleChangeFile('fileQualificationUrl','fileQualification', file,'pdf')"
                            >
                            <el-button size="small" type="primary">点击上传PDF文件</el-button>
                              <el-input size="small" v-model= "forme.fileQualification" v-if="forme.fileQualification" style="width: 10rem"  disabled clearable></el-input>
                            </el-upload>
                    </el-form-item>
                </el-descriptions-item>
            </el-descriptions>

            <!-- 现行专有标准或技术规范，上传多个文件，列表 -->

          <el-descriptions title="现行专有标准或技术规范" class="step_page_des" ></el-descriptions>
          <el-form-item prop="fileLists">
            <el-upload
              class="upload-container"
              :accept= "acceptPDF"
              :before-upload="beforeUploadPDF"
              action="#"
              ref="fileUploadBtn"
              multiple
              :show-file-list="false"
              :auto-upload="true"
              :http-request="handleChangeFile2"
              :on-change="handleChange"
              :file-list="fileLists">
              <el-button size="small" type="primary">可选一个或多个PDF文件</el-button>
<!--              -->
            </el-upload>
          </el-form-item>
            <el-table :data="fileLists" :cell-style="cellStyles"  :header-cell-style="headerStyles"  border style="width: 100%;margin-top: 1.5rem">

              <el-table-column  width="200" prop="fileStandard" label="文件名"></el-table-column>
              <el-table-column width="120" prop="size" label="大小"  ></el-table-column>
              <el-table-column  width="120"  label="状态">
                <template slot-scope="scope" >
                   {{scope.row.fileStandardUrl ? '已上传' : '未上传'}}
                </template>
              </el-table-column>
              <el-table-column  width="180" label="标准规范类型">
                <template slot-scope="scope" >
                  <el-select v-model= "scope.row.standardType" placeholder="请选择" @change="jcChange"  style="width: 100%;">
                    <el-option  disabled label="规范类型" value="规范类型"></el-option>
                    <el-option   label="国家标准" value="国家标准"></el-option>
                    <el-option   label="省级地方标准" value="省级地方标准"></el-option>
                    <el-option   label="标准技术规范" value="标准技术规范"></el-option>
                    <el-option   label="企业规范" value="企业规范"></el-option>
                    <el-option   label="企业标准" value="企业标准"></el-option>
                    <el-option   label="省级地方标准（建议草案稿）" value="省级地方标准（建议草案稿）"></el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column  width="220"  label="标准规范编号">
                <template slot-scope="scope" >
                  <el-input size="mini"  @change="jcChange"  v-model = "scope.row.standardNum"></el-input>
                </template>
              </el-table-column>
              <el-table-column  label="操作">
                <template slot-scope="scope" >
                  <el-button  type="text"  style="color: rgb(219, 29, 48)"   size="small" @click="toDelete(scope.row.uid)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>

          <el-button type="primary" v-if="isUpload"  @click="toUpLoadPdf">开始上传</el-button>

          <div v-else>注：选择文件并填写完整后方可上传</div>


          <el-descriptions title="产品检测报告" border :column="1"  class="step_page_des" label-class-name="my-labeljf" content-class-name="my_content_border">
            <el-descriptions-item label="产品检测报告">

              <el-form-item prop="fileTestReport" >
                <el-upload
                action="#"
                ref="fileTestReport"
                class="upload-container"
                :accept="acceptPDF"
                :before-upload="beforeUploadPDF"
                :auto-upload="true"
                :on-preview="handlePreview"
                :on-remove="handleRemove"
                :on-change="(file, fileList) =>fileChange('fileTestReport',file, fileList)"
                :before-remove="beforeRemove"
                :on-exceed="handleExceed"
                :show-file-list="false"
                :limit = 1
                :http-request="(file, fileList) => handleChangeFile('fileTestReportUrl','fileTestReport', file, 'pdf')"

                :file-list="fileList">
                  <el-button size="small" type="primary">选择PDF文件</el-button>
                  <el-input size="small" v-model= "forme.fileTestReport" v-if="forme.fileTestReport" style="width: 10rem"  disabled clearable></el-input>
                </el-upload>
              </el-form-item>

            </el-descriptions-item>
          </el-descriptions>




          <el-descriptions  border :column="1" :size="size" class="step_page_des" label-class-name="my-labeljf" content-class-name="my_content_border">
            <el-descriptions-item label="其他证明材料(非必填)">

              <el-form-item >
                <el-upload
                action="#"
                ref="fileOther"
                class="upload-container"
                :accept="acceptZIP"
                :before-upload="beforeUploadZip"
                :auto-upload="true"
                :on-preview="handlePreview"
                :on-change="(file, fileList) =>fileChange('fileOther',file, fileList)"
                :on-remove="handleRemove"
                :before-remove="beforeRemove"
                :on-exceed="handleExceed"
                :show-file-list="false"
                :limit = 1
                :http-request="(file, fileList) => handleChangeFile('fileOtherUrl','fileOther', file, 'zip')"
                :file-list="otherfileLists">
                  <el-button size="small" type="primary">选择压缩文件</el-button>
                  <el-input size="small" v-model= "forme.fileOther" v-if="forme.fileOther" style="width: 10rem"  disabled clearable></el-input>
                </el-upload>
              </el-form-item>

            </el-descriptions-item>
          </el-descriptions>



          <div>
            佐证材料填报说明 :<br/>
            产品生产销售的佐证材料包括产品的包装与合同等能够证明产品名称已广泛运用到生产销售中的证明材料、产品市场占有率、出口情况、消费主体、与同类产品价格对比情况、产品拟用标企业名单、拟用标企业占产区范围内企业总数的比值、拟用标企业产值情况等
          </div>

          <div>

          </div>








        </div>
      </el-form>
      <el-form  :inline="true" :model= "forme" ref="active3" class="demo-form-inline" :rules="rules">
        <!-- 步骤4.产品情况说明 -->
        <div v-if="active===3">
            <el-descriptions title="产品情况说明" border :column="1" :size="size" class="step_page_des" label-class-name="my-labeljf" content-class-name="my_content_border">
                <el-descriptions-item label="产品历史渊源(必填)："><el-form-item prop="historical"><QuillEditor v-model= "forme.historical" /></el-form-item><p class="step_note">备注：应具体说明申请保护的地理标志产品在产地的生产历史、申请保护的地理标志产品名称持续使用时间和当前实际使用情况，并提供相关佐证材料</p></el-descriptions-item>
                <el-descriptions-item label="产品名称历史渊源证明材料(必填)：">
                        <el-form-item prop="fileNameHistorical">
                            <el-upload
                            action="#"
                            ref="fileNameHistorical"
                            class="upload-container"
                            :accept="acceptPDF"
                            :before-upload="beforeUploadPDF"
                            :on-change="(file, fileList) =>fileChange('fileNameHistorical',file, fileList)"
                            :auto-upload="true"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :before-remove="beforeRemove"
                            :on-exceed="handleExceed"
                            :show-file-list="false"
                            :limit = 1
                            :file-list="fileList"
                            :http-request="(file) => handleChangeFile('fileNameHistoricalUrl','fileNameHistorical', file,'pdf')"
                            >
                            <el-button size="small" type="primary">点击上传PDF文件</el-button>
                              <el-input size="small" v-model= "forme.fileNameHistorical" v-if="forme.fileNameHistorical" style="width: 10rem"  disabled clearable></el-input>
                            </el-upload>
                    </el-form-item>
                      <p class="step_note">备注：佐证材料一般为公开出版物和省级以上媒体公开发表的电视、网络宣传报道，应包括地方志，可以包括其他公开过且可查询的文学作品、新闻报道、学术论文等</p>
                </el-descriptions-item>

                    <el-descriptions-item label="产品生产销售(必填)："><el-form-item prop="productSell"><QuillEditor v-model= "forme.productSell" /></el-form-item>
                    <p class="step_note">备注：应说明申请保护的地理标志产品在产地内具有良好的生产情况，并提供相关佐证材料。相较于同类产品，生产者构成应较为合理，原则上，产地应具有规模以上的地理标志产品生产企业，企业数量不应仅少数几家；应具有较高的经济效益；应具有较大的、合理的产值、产量和生产规模。</p>
                    </el-descriptions-item>
                <el-descriptions-item label="产品生产销售证明材料(必填)：">
                        <el-form-item prop="fileProductSell">
                            <el-upload
                            action="#"
                            ref="fileProductSell"
                            class="upload-container"

                            :on-change="(file, fileList) =>fileChange('fileProductSell',file, fileList)"
                            :accept="acceptPDF"
                            :before-upload="beforeUploadPDF"
                            :auto-upload="true"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :before-remove="beforeRemove"
                            :on-exceed="handleExceed"
                            :show-file-list="false"
                            :limit = 1
                            :file-list="fileList"
                            :http-request="(file) => handleChangeFile('fileProductSellUrl','fileProductSell', file,'pdf')"
                            >
                            <el-button size="small" type="primary">点击上传PDF文件</el-button>
                              <el-input size="small" v-model= "forme.fileProductSell" v-if="forme.fileProductSell" style="width: 10rem"  disabled clearable></el-input>
                            </el-upload>
                    </el-form-item>
                        <p class="step_note">备注：1.佐证材料应包括地方人民政府或相关产业主管部门近3年涉及该产品产量、产值、生产规模的相关文件，产品生产者构成及拟使用地理标志专用标志企业名单；可以包括产品单价及其与同类产品的价格对比表；产品销售地区、销量、市场占有率说明，以及相应的销售合同、发票、出货单、海关出口货物报关单等。</p>
                        <p class="step_note">2.必须上传的项目：（1）产品生产者名单及重点企业的产值；（2）产品总体产值、经济效益情况；（3）产品单价及其与同类产品的价格比较；（4）产品销售的地区及销量。</p>
                        <p class="step_note">3.可选择上传的项目：（5）其他产品生产销售证明材料。</p>
                        <p class="step_note">以上项目包含在一个pdf文件中。</p>
                </el-descriptions-item>

                    <el-descriptions-item label="产品知名度(必填)："><el-form-item prop="popularity"><QuillEditor v-model= "forme.popularity" /></el-form-item>
                    <p class="step_note">备注：应说明申请保护的地理标志产品在全国或国内较大区域内享有较好声誉和较大影响力，并提供相关佐证材料。</p>
                    </el-descriptions-item>
                <el-descriptions-item label="产品知名度证明材料(必填)：">
                        <el-form-item prop="fileProfile">
                            <el-upload
                            action="#"
                            ref="fileProfile"
                            class="upload-container"
                            :on-change="(file, fileList) =>fileChange('fileProfile',file, fileList)"
                            :accept="acceptPDF"
                            :before-upload="beforeUploadPDF"
                            :auto-upload="true"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :before-remove="beforeRemove"
                            :on-exceed="handleExceed"
                            :show-file-list="false"
                            :limit = 1
                            :file-list="fileList"
                            :http-request="(file) => handleChangeFile('fileProfileUrl','fileProfile', file,'pdf')"
                            >
                            <el-button size="small" type="primary">点击上传PDF文件</el-button>
                              <el-input size="small" v-model= "forme.fileProfile" v-if="forme.fileProfile" style="width: 10rem"  disabled clearable></el-input>
                            </el-upload>
                    </el-form-item>
                    <p class="step_note">备注：1.佐证材料应包括该产品获得的全国性或国内较大区域内的荣誉和奖项等，可包括相关行业专家、从业者、消费者评价，知名媒体新闻报道、广告宣传等。</p>
                    <p class="step_note">2.必须上传的项目：（1）新闻报道；（2）荣誉奖项。</p>
                    <p class="step_note">3.可选择上传的项目：（3）其他产品知名度证明材料。</p>
                    <p class="step_note">以上项目包含在一个pdf文件中。</p>
                </el-descriptions-item>

            </el-descriptions>
        </div>
      </el-form>
      <el-form  :inline="true" :model= "forme" ref="active4" class="demo-form-inline" :rules="rules">
        <!-- 步骤5.质量特色,保护要求 -->
        <div v-if="active===4">
            <el-descriptions title="产品质量特色说明" border :column="1" :size="size" class="step_page_des" label-class-name="my-labeljf" content-class-name="my_content_border">
                <el-descriptions-item label="感官特色："><el-form-item prop="sensoryCharacter"><QuillEditor v-model= "forme.sensoryCharacter" maxLength="300"/></el-form-item><p class="step_note">备注：应具体说明申请保护的地理标志产品在产地的生产历史、申请保护的地理标志产品名称持续使用时间和当前实际使用情况，并提供相关佐证材料</p></el-descriptions-item>
                <el-descriptions-item label="理化指标："><el-form-item prop="pcIndexes"><QuillEditor v-model= "forme.pcIndexes" maxLength="1000"/></el-form-item><p class="step_note">备注：应具体说明申请保护的地理标志产品在产地的生产历史、申请保护的地理标志产品名称持续使用时间和当前实际使用情况，并提供相关佐证材料</p></el-descriptions-item>
            </el-descriptions>

            <el-descriptions title="产品保护要求" border :column="1" :size="size" class="step_page_des" label-class-name="my-labeljf" content-class-name="my_content_border">
                <el-descriptions-item label="产品保护要求（doc或docx文件）：">
                        <el-form-item prop="fileProductProtection">
                            <el-upload
                            action="#"
                            ref="fileProductProtection"
                            class="upload-container"
                            :accept="acceptDOC"
                            :on-change="(file, fileList) =>fileChange('fileProductProtection',file, fileList)"
                            :before-upload="beforeUploadDOC"
                            :auto-upload="true"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :before-remove="beforeRemove"
                            :on-exceed="handleExceed"
                            :limit = 1
                            :file-list="fileList"
                             :http-request="(file) => handleChangeFile('fileProductProtectionUrl','fileProductProtection', file,'doc')"
                            >
                            <el-button size="small" type="primary">上传doc或docx文件</el-button>
                              <el-input size="small" v-model= "forme.fileProductProtection" v-if="forme.fileProductProtection" style="width: 10rem"  disabled clearable></el-input>
                            </el-upload>
                    </el-form-item>
                </el-descriptions-item>
            </el-descriptions>


        </div>
      </el-form>
      <el-form  :inline="true" :model= "forme" ref="active5" class="demo-form-inline" :rules="rules">
        <!-- 步骤6.商标,农产品信息 -->
        <div v-if="active===5">
              <el-descriptions title="商标及农产品信息" border :column="2" :size="size" class="step_page_des" label-class-name="my-labeljf" content-class-name="my_content_border">
                <el-descriptions-item label="是否存在注册商标：">
                    <el-form-item prop="isTrademark">
                      <el-radio-group v-model="forme.isTrademark">
                        <el-radio :label="1">是</el-radio>
                        <el-radio  :label="0">否</el-radio>
                      </el-radio-group>


                        </el-form-item>
                        </el-descriptions-item>
                <el-descriptions-item v-if= "forme.isTrademark==1" label="商标类别 ："><el-form-item prop="trademarkType">
                    <el-select v-model= "forme.trademarkType" placeholder="请选择">
                            <el-option
                            v-for= "item in trademarkTypeOptions"
                            :key= "item.value"
                            :label= "item.label"
                            :value= "item.label">
                            </el-option>
                    </el-select></el-form-item></el-descriptions-item>
                <el-descriptions-item v-if= "forme.isTrademark==1" label="商标注册证：">
                          <el-form-item prop="fileTrademarkCard">
                            <el-upload
                            action="#"
                            ref="fileTrademarkCard"
                            class="upload-container"
                            :on-change="(file, fileList) =>fileChange('fileTrademarkCard',file, fileList)"
                            :accept="acceptPDF"
                            :before-upload="beforeUploadPDF"
                            :auto-upload="true"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :before-remove="beforeRemove"
                            :on-exceed="handleExceed"
                            :show-file-list="false"
                            :limit = 1
                            :file-list="fileList"
                            :http-request="(file) => handleChangeFile('fileTrademarkCardUrl','fileTrademarkCard', file,'pdf')"
                            >
                            <el-button size="small" type="primary">点击上传PDF文件</el-button>
                              <el-input size="small" v-model= "forme.fileTrademarkCard" v-if="forme.fileTrademarkCard" style="width: 10rem"  disabled clearable></el-input>
                            </el-upload>
                    </el-form-item></el-descriptions-item>
                        <el-descriptions-item v-if= "forme.isTrademark==1" label="证明商标初步审定公告或证明商标使用管理规则：">
                          <el-form-item prop="fileTrademark">
                            <el-upload
                            action="#"
                            ref="fileTrademark"
                            class="upload-container"
                            :on-change="(file, fileList) =>fileChange('fileTrademark',file, fileList)"
                            :accept="acceptPDF"
                            :before-upload="beforeUploadPDF"
                            :auto-upload="true"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :before-remove="beforeRemove"
                            :on-exceed="handleExceed"
                            :show-file-list="false"
                            :limit = 1
                            :file-list="fileList"
                            :http-request="(file) => handleChangeFile('fileTrademarkUrl','fileTrademark', file,'pdf')"
                            >
                            <el-button size="small" type="primary">点击上传PDF文件</el-button>
                              <el-input size="small" v-model= "forme.fileTrademark" v-if="forme.fileTrademark" style="width: 10rem"  disabled clearable></el-input>
                            </el-upload>
                    </el-form-item></el-descriptions-item>

                      <el-descriptions-item label="是否为农产品 ：">
                        <el-form-item prop="isAgricultural">
                          <el-radio-group v-model="forme.isAgricultural">
                            <el-radio  :label="1">是</el-radio>
                            <el-radio  :label="0">否</el-radio>
                          </el-radio-group>
                        </el-form-item>
                            </el-descriptions-item>
                        <el-descriptions-item v-if= "forme.isAgricultural=='1'" label="农产品地理标志注册证：">
                          <el-form-item prop="fileAgriculturalCard">
                            <el-upload
                            action="#"
                            class="upload-container"
                            :accept="acceptPDF"
                            ref="fileAgriculturalCard"
                            :before-upload="beforeUploadPDF"
                            :auto-upload="true"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :before-remove="beforeRemove"
                            :on-exceed="handleExceed"
                            :show-file-list="false"
                            :limit = 1
                            :file-list="fileList"
                            :http-request="(file) => handleChangeFile('fileAgriculturalCardUrl','fileAgriculturalCard', file,'pdf')"
                            >
                            <el-button size="small" type="primary">点击上传PDF文件</el-button>
                              <el-input size="small" v-model= "forme.fileAgriculturalCard" v-if="forme.fileAgriculturalCard" style="width: 10rem"  disabled clearable></el-input>
                            </el-upload>
                    </el-form-item></el-descriptions-item>

                         <el-descriptions-item v-if= "forme.isAgricultural=='1'" label="农产品地理标志质量控制技术规范：">
                          <el-form-item prop="fileAgricultural">
                            <el-upload
                            action="#"
                            class="upload-container"
                            :accept="acceptPDF"
                            ref="fileAgricultural"
                            :before-upload="beforeUploadPDF"
                            :auto-upload="true"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :before-remove="beforeRemove"
                            :on-exceed="handleExceed"
                            :show-file-list="false"
                            :limit = 1
                            :file-list="fileList"
                            :http-request="(file) => handleChangeFile('fileAgriculturalUrl','fileAgricultural', file,'pdf')"
                            >
                            <el-button size="small" type="primary">点击上传PDF文件</el-button>
                              <el-input size="small" v-model= "forme.fileAgricultural" v-if="forme.fileAgricultural" style="width: 10rem"  disabled clearable></el-input>
                            </el-upload>
                    </el-form-item></el-descriptions-item>



            </el-descriptions>

        </div>
      </el-form>
      <el-form  :inline="true" :model= "forme" ref="active6" class="demo-form-inline" :rules="rules">
        <!-- 步骤7.完成 -->
        <div v-if="active===6">
           <!-- 提交成功后页面 -->
            <div v-if="isShow == 'save'">
                <p>电子提交成功，申请号为{{applicationId}}</p>
                <!-- <el-button @click="toDrafts('/land')">再次申请</el-button> -->
                <el-button @click="toApply">再次申请</el-button>

                <el-button @click="toDetails">查看详情</el-button>
<!--                <el-button @click="toPj">去评价</el-button>-->

            </div>


            <!-- 暂存成功后页面-->

              <div v-if="isShow == 'saveTemp'">
                <p>已暂存，请到草稿箱编辑提交！</p>
                <p>暂存时间限制为90天，从第一次暂存开始计算，请尽快完成信息的收集，将其填入系统并提交申请!!!</p>
                <el-button @click="toDrafts('/drafts')">进入草稿箱</el-button>
              </div>

        </div>
      </el-form>
    </div>

    <div class="step-btn">
        <!-- 步骤1时不显示“上一步”，步骤7时不显示“下一步” -->
        <el-button @click="goBack" v-show="0 < active && active<=5" >上一步</el-button>
        <el-button :disabled="active < 1" v-if="active != 6" @click="saveTemp('active5')">暂存</el-button>

        <el-button @click="next" v-if="active <5">下一步</el-button>
        <el-button @click="save('active5')" v-if="active ==5">提交</el-button>
    </div>

    <!-- 分割线 -->
    <div class="divider"></div>

    <div>
        <p>更新说明</p>
         <p>2024-01-31 地理标志产品保护申请信息表内容调整</p>
          <p>说明</p>

          <!-- 文字超链接 -->

           <p>《产品保护申请用户使用手册》</p>
           <p>1填写完成后点击“下一步”进行其他信息填写，最终点击“提交”完成申请填报</p>
           <p>2除标记为“非必填”外的字段，全部需要填写、选择或上传文件</p>
           <p>3文件上传“产品类别”需上传产品图片，“产品保护要求”需上传.doc或.docx文件，“压缩文件”要求为ZIP、RAR、7Z中的一种，其余文件都需要上传PDF文件</p>
           <p>4单个文件上传不得超过20MB</p>


    </div>

  <!--好差评弹窗 -->
  <el-dialog  :visible.sync="pjSrcIsshow" width="70%">
    <iframe
      class="prism-player"
      frameborder="0"
      :src="pjSrc"
      allowTransparency="true"
    ></iframe>
  </el-dialog>






</div>
</template>

<script>
import QuillEditor from '../../components/QuillEditor.vue'
import {getProductType, uploadPdfFile,uploadImgFile,saveDrafts,submitApplication,uploadZipFile,uploadDocFile,checkname} from '../../api/landmarkApplication1'
import {applydrafts, superiors} from "../../api/landmarkApplication";
import {pJsubmit} from "../../api/login";
export default {
    name: 'index',
    components:{QuillEditor},
    props:['isDraft','applyId','isBz','isDraftNum'],
    data() {

      // const validateUploadImage = (rule, value, callback) =>{
      //   if(this.iamgefile1 && this.iamgefile1.length === 0) {
      //       callback(new Error('请上传产品图片11'))
      //     } else {
      //     this.$refs['upload1'].clearValidate()
      //       callback()
      //     }
      // }

      const validatefileApply = (rule, value, callback) =>{
        if(this.forme.fileApply && this.forme.fileApply.length === 0) {
            callback(new Error('请上传产品图片'))
          } else {
            callback()
          }
      }

      const validatefileAddress = (rule, value, callback) =>{
        if(this.forme.fileAddress && this.forme.fileAddress.length === 0) {
            callback(new Error('请上传产品图片'))
          } else {
            callback()
          }
      }

      const validatefileApplyProtection = (rule, value, callback) =>{
        if(this.forme.fileApplyProtection && this.forme.fileApplyProtection.length === 0) {
            callback(new Error('请上传产品图片'))
          } else {
            callback()
          }
      }

      const validatefileLists = (rule, value, callback) =>{
        if(this.forme.fileLists && this.forme.fileLists.length === 0) {
            callback(new Error('请上传现行专有标准或技术规范'))
          } else {
            callback("错误了")
          }
      }

      const validatefileTestReport = (rule, value, callback) =>{
        if(this.forme.fileTestReport && this.forme.fileTestReport.length === 0) {
            callback(new Error('请上传产品图片'))
          } else {
            callback()
          }
      }

      const validateContact = (rule, value, callback) => {
        const regMobile = /^1[3-9]\d{9}$/; // 正则表达式匹配手机号
        const regTelephone = /^(\(\d{3,4}\)|\d{3,4}-)?\d{7,8}$/; // 正则表达式匹配座机号
        if (value === '') {
          callback(new Error('请输入座机号或者手机号'));
        } else if (!regMobile.test(value) && !regTelephone.test(value)) {
          callback(new Error('请输入正确的座机号或者手机号'));
        } else {
          callback();
        }
      };


      return {
        pjSrcIsshow:false,
        pjSrc:'',
        userInfo:'',
        active:0,
        isShow:'',
        applyIds:'',
        headerStyles:
            {
              padding: '0.375rem',
              'border-right': '2px solid #ffffff',
              'text-align': 'center',
              background: 'rgb(27, 61, 109)'
        },
        cellStyles: {'text-align': 'center',},
          //表格数据
        tableData: [],
        verticalData:[
            {label: '产品基本信息', value: 0},
            {label: '申报部门信息', value: 1},
            {label: '申报材料', value: 2},
            {label: '产品情况说明', value: 3},
            {label: '质量特色,保护要求', value: 4},
            {label: '商标,农产品信息', value: 5},
            {label: '完成', value: 6}
        ],
        iamgefileList1:'',
        forme: {

          fileList:[],
          applyTypeId:'',
            name:'', //产品中文名称
            namePinyin:'', //拼音名
            nameEnglish:'',//英文名（非必填）
            applyType1:'',//产品类型
            applyType2:'',//产品类型二级
            applyType3:'',//产品类型三级
            otherApplyType:'',//其他产品类型（当产品类型为“其他”时，必填）
            originRange:'',//县级以上人民政府建议的地理标志产品保护范围
            description:'',//产品描述

            applyName:'',
            applyAddress:'',
            applyContacts:'',
            applyPhone:'',
            applyFax:'',
            applyEmail:'',
            originName:'',
            originAddress:'',
            originContacts:'',
            originPhone:'',
            originFax:'',
            originEmail:'',

            historical:'',
            productSell:'',
            popularity:'',

            sensoryCharacter:'',
            pcIndexes:'',


            isTrademark:0,
            trademarkType:'',

            isAgricultural:0,

            fileQualification:'',//申报机构资质证明 当地县级以上人民政府关于成立申报机构或指定协会、企业作为申请人的文件
            fileQualificationUrl:'',//申报机构资质证明文件地址

            fileNameHistorical:'',//产品名称历史渊源
            fileNameHistoricalUrl:'',//产品名称历史渊源明材料地址

            fileProfile:'',//产品知名度
            fileProfileUrl:'',//产品知名度证明材料地址

            fileAddress:'',//县级以上人民政府界定保护范围的建议的文件
            fileAddressUrl:'',

            fileApply:'',//地理标志产品保护申请书
            fileApplyUrl:'',//

            fileApplyProtection:'',//县级以上人民政府申请保护文件：
            fileApplyProtectionUrl:'',

            otherCategories:'',//产品图片
            otherCategoriesUrl:'',

            fileTestReport:'',//产品检测报告
            fileTestReportUrl:'',//

            fileTrademark:'',//商标申明文件或法律文件
            fileTrademarkUrl:'',

            fileTrademarkCard:'',//商标注册证
            fileTrademarkCardUrl:'',

            fileProductProtection:'',//产品保护要求（DOC）
            fileProductProtectionUrl:'',


            fileProductSell:'',//产品生产销售及有关情况
            fileProductSellUrl:'',

            fileOther:'',//其他证明材料(非必填)
            fileOtherUrl:'',


            fileAgricultural:'',//农产品地理标志质量控制技术规范
            fileAgriculturalUrl:'',//



            applyType:'',//产品类型内容
            state:'',

            standardDTOs:[],//现行专有标准或技术规范

            applyUserId:'',

            fileAgriculturalCard:'', //农产品地理标志注册证
            fileAgriculturalCardUrl:'',






        },
        trademarkTypeOptions:[
            {label:'证明商标',value:'证明商标'},
            {label:'普通商标',value:'普通商标'},
            {label:'集体商标',value:'集体商标'}
        ],
        applyType1Options:[],
        applyType2Options:[],
        applyType3Options:[],

        iamgefile:[],


        rules: {
          // 第一步验证
          // name: [ { required: true, message: '请输入中文名称', trigger: 'blur' }, { validator: this.validateChinese, trigger: 'blur' }],
          name: [ { required: true, message: '请输入中文名称', trigger: 'blur' }],
          namePinyin: [ { required: true,validator:this.validatepinyin, message: '请输入产品中文名称(拼音)', trigger: 'blur' }],
          nameEnglish: [{ required: true, message: '请输入中文名称', trigger: 'blur' }],
          applyType1: [ { required: true, message: '请选择产品类型', trigger: 'change' } ],
          applyType2: [{ required: true, message: '请选择其他产品类别', trigger: 'change' }],
          applyType3: [{ required: true, message: '请输入产品类型', trigger: 'change' }],


          otherCategories: [{ required: true, message:'请上传产品图片', trigger: ['blur'] }],
          fileApply: [{ required: true, message:'请上传文件', trigger: ['blur'] }],
          fileAddress: [{ required: true, message:'请上传文件', trigger: ['blur'] }],
          fileApplyProtection: [{ required: true, message:'请上传文件', trigger: ['blur'] }],
          fileTestReport: [{ required: true, message:'请上传文件', trigger: ['blur'] }],
          fileOther: [{ required: true, message:'请上传文件', trigger: ['blur'] }],
          fileAgricultural: [{ required: true, message:'请上传文件', trigger: ['blur'] }],
          fileAgriculturalCard: [{ required: true, message:'请上传文件', trigger: ['blur'] }],

          fileTrademark: [{ required: true, message:'请上传文件', trigger: ['blur'] }],
          fileTrademarkCard: [{ required: true, message:'请上传文件', trigger: ['blur'] }],
          fileProductProtection: [{ required: true, message:'请上传文件', trigger: ['blur'] }],
          fileProfile: [{ required: true, message:'请上传文件', trigger: ['blur'] }],
          fileProductSell: [{ required: true, message:'请上传文件', trigger: ['blur'] }],
          fileNameHistorical: [{ required: true, message:'请上传文件', trigger: ['blur'] }],
          fileQualification:[{ required: true, message:'请上传文件', trigger: ['blur'] }],



          originRange: [{ required: true, message: '请输入产品保护范围', trigger: 'blur' }],
          description: [{ required: true, message: '请输入产品描述', trigger: 'blur' }],
          // 第二步验证
          applyName: [ { required: true,message: '请填写申报机构名称', trigger: 'blur' }],
          applyAddress: [ { required: true, message: '请输入申报机构通信地址', trigger: 'blur' }],
          applyContacts: [ { required: true,validator:this.validateChinese, message: '请输入纯中文联系人姓名', trigger: 'blur' }],
          applyPhone: [ { required: true,validator: validateContact,  trigger: 'blur' }],
          applyFax: [ { required: true, message: '请输入传真号', trigger: 'blur' }, { pattern: /^(\d{7,20}|0\d{2,3}-\d{7,8})$/, message: '请输入有效的传真号', trigger: 'blur' }],
          applyEmail: [ { required: true, type: 'email', message: '请输入申报机构电子邮箱', trigger: 'blur' }],
          originName: [ { required: true,validator:this.validateChinese, message: '请输入单位名称', trigger: 'blur' }],
          originAddress: [ { required: true, message: '请输入通信地址', trigger: 'blur' }],
          originContacts: [ { required: true, validator:this.validateChinese, message: '请输入单位联系人', trigger: 'blur' }],
          originPhone: [ { required: true,validator: validateContact, trigger: 'blur' }],
          originFax: [  { required: true, message: '请输入传真号', trigger: 'blur' }, { pattern: /^(\d{7,20}|0\d{2,3}-\d{7,8})$/, message: '请输入有效的传真号', trigger: 'blur' }],
          originEmail: [ { required: true, type: 'email', message: '请输入单位电子邮箱', trigger: 'blur' }],
          // 第三步





        // 第四步
        historical:[{ required: true, message: '请输入必填项', trigger: 'blur' }],

        productSell:[{ required: true, message: '请输入必填项', trigger: 'blur' }],

        popularity:[{ required: true, message: '请输入必填项', trigger: 'blur' }],

        //第五步
        sensoryCharacter:[{ required: true, message: '请输入必填项', trigger: 'blur' }],
        pcIndexes:[{ required: true, message: '请输入必填项', trigger: 'blur' }],


        //第六步













        },
        size: 'default',
        acceptPDF:'application/pdf',
        acceptIMG:'image/jpeg,image/png,image/jpg',
        acceptDOC:'application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        acceptZIP:'application/zip,application/x-zip-compressed,application/x-compressed,application/x-7z-compressed,application/x-rar-compressed',
        acceptRAR:'application/rar,application/x-rar-compressed',
        accept7Z:'application/x-7z-compressed,application/x-compressed,application/x-rar-compressed',
        formInline:{},
        datas1:'',
        isUpload:false,
        fileList:[],
        fileLists:[],
        fileListImg:[],//
        iamgefile1:[],
        otherfileLists:[],//其他证明材料列表

        isShowApplyType3:false,
        applicationId:''




      }
    },
  watch:{

    //
    'forme.applyType1':function (val){


      if (val != ''){
        // console.log(12345)
        if (val != 5){
          this.getProduct2Types(val)
        }else {
          this.applyType2Options = []
          this.applyType3Options = []
        }

      }



      else {
        this.forme.applyType2 = ''
      }

    }
    ,
    'forme.applyType2':function (val){
      // console.log(val,555)
      if(val != ''){
        this.getProduct3Types(val)
      }else {
        this.forme.applyType3 = ''
      }

    },



    // 如果applyType3Options非空，则this.isShowApplyType3 = true
    applyType3Options(val){
      if(val.length){
        this.isShowApplyType3 = true
      }else{
        this.isShowApplyType3 = false
      }
    }

  },

  created() {
    this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))  || ''
  },
  mounted(){
  let _this = this




    this.getProduct1Types(0)

      //草稿箱引用时，获取回显数据
      if (this.isDraft){

        applydrafts(this.applyId).then(res=>{
          this.forme = res.data

          this.fileLists = res.data.standardDTOs
          if (res.data.applyTypeId.toString().length  == 1){ // 其他
            this.forme.applyType1 = res.data.applyTypeId

            // console.log(222)




          }else {

            superiors({applyTypeId:res.data.applyTypeId}).then(res=>{
              res.data.forEach((ite,indx)=>{
                if (ite.superiorTypeId.toString().length == 1){
                  _this.$set(_this.forme, 'applyType1', ite.superiorTypeId)

                  _this.$set(_this.forme, 'applyType2', ite.id)
                  // console.log(_this.forme.applyType1,6677)

                }
                if (ite.superiorTypeId.toString().length == 3){
                  _this.$set(_this.forme, 'applyType3', ite.id)

                }



              })

            })
          }







        })
      }

    },


    methods: {

      validatepinyin(rule, value, callback) {
        const regex = /^[A-Za-z ]+$/;
        if (!value) {
          return callback(new Error('Input cannot be empty'));
        } else if (!regex.test(value)) {
          return callback(new Error('Only English letters allowed'));
        }
        callback();
      },

      validateChinese(rule, value, callback) {
        const reg = /^[\u4e00-\u9fa5]+$/;
        if (!reg.test(value)) {
          callback(new Error('只能输入中文'));
        } else {
          callback();
        }
      },

      changeValue1(val){
        // console.log(123456789)

      },
      //上一步
      goBack(){
        this.active --
        this.$refs.topDiv.scrollIntoView({ behavior: 'smooth' });
      },

      //下一步
      next(){
        this.$refs.topDiv.scrollIntoView({ behavior: 'smooth' });
        let validvalue = 'active' + this.active
        this.$refs[validvalue].validate((valid) => {

          // if (this.forme.iamgefileListName1 != ''){
          //   if (valid) {
          //     this.active++
          //   }
          // }else {
          // }

          if(valid){
            if(this.active==2&&this.forme.standardDTOs.length==0){
              this.$message.error('请填写或上传现行专有标准或技术规范！')
              return
            }
            this.active++
          }else{
            this.$message.error('请根据页面提示填写必填项！')
          }

        })




      },
      //检查列表输入框是否全部非空
      checkAllInputs() {
        for (let row of this.fileLists) {
          if (!row.standardType.trim()  || !row.standardNum.trim()) {
            this.$message.error('存在未填写的输入框');
            return;
          }
        }
       this.isUpload = true
      },

      //上传pdf---现行专有标准或技术规范
      toUpLoadPdf(){
        this.fileLists.forEach((item,index)=>{
          let obj =    this.uploadFile(item.raw,'pdf')
          obj.then(res=>{
            item.fileStandardUrl = res.filePath
            item.fileStandard = res.fileName
          })

          this.isUpload = false

          this.$set( this.fileLists,index,item)
        })

        this.forme.standardDTOs = this.fileLists
      },

      //上传文件
      uploadFile(file,type){
        let  formData = new FormData()
        formData.append('file',file)
        let obj = ''
        if (type =='img'){  //
            obj =    uploadImgFile(formData).then(res=>{
              if (res.errorCode == 200){
                this.$message.success('上传成功')
                return res.data
              }else{
                 this.$message.error(res.errorMsg)
              }

            })

        }
        if (type == 'pdf'){
          obj =    uploadPdfFile(formData).then(res=>{
            if (res.errorCode == 200){
              this.$message.success('上传成功')
              return res.data
            }else{
               this.$message.error(res.errorMsg)
            }

          })

        }
        if (type == 'doc'){
               obj =    uploadDocFile(formData).then(res=>{
            if (res.errorCode == 200){
              this.$message.success('上传成功')
              return res.data
            }else{
               this.$message.error(res.errorMsg)
            }

          })


        }
        if (type == 'zip'){
        obj =    uploadZipFile(formData).then(res=>{
            if (res.errorCode == 200){
              this.$message.success('上传成功')
              return res.data
            }else{
               this.$message.error(res.errorMsg)
            }

          })


        }
        return obj
      },

      jcChange(){
       this.checkAllInputs()
      },

        //获取产品类型 0：产品类型，1：食用农林产品，2：非使用农林产品，3：中药材，4：手工艺品
        getProduct1Types(type){
            let params={
                superiorTypeId:type
            }
            getProductType(params).then(res=>{
                if(res.errorCode == 200){
                    this.applyType1Options = res.data;
                }
            })

        },
      handleChangeFile2(file){
        // console.log(file,4444)
      },
      handleChange (file, fileList) {
        this.fileLists = fileList
        this.fileLists.forEach(ite=>{
         if ( !ite.fileStandard ){
           ite.fileStandard = ite.name
         }
        })
      },
        getProduct2Types(type){
          this.applyType2Options = []
            getProductType({superiorTypeId:type}).then(res=>{
                if(res.errorCode == 200){
                    this.applyType2Options = res.data
                }
            })

        },
        getProduct3Types(type){
          this.applyType3Options = []
            getProductType({superiorTypeId:type}).then(res=>{
                if(res.errorCode == 200){
                    this.applyType3Options = res.data
                }
            })

        },

      fileChange(name,uploadFile, fileList) {
        // this.$refs.fileUploadBtn.clearFiles(); // 清缓存
        if (name == 'fileProductProtection'){  //doc
          this.forme[name] = uploadFile.name
          this.$refs['active' + this.active].clearValidate(name);

        }else {
          if (uploadFile.name.split(',')[1] == 'pdf'){
            this.forme[name] = uploadFile.name
            this.$refs['active' + this.active].clearValidate(name);
          }else {
            this.$refs['active' + this.active].clearValidate(name);
            // this.$message.warning('文件格式不正确')

          }

        }



      },

      changeInput(val){

        if (this.forme.name != ''){
          checkname({name:this.forme.name,applyId:this.applyId || -1}).then(res=>{
            if (res.errorCode == 200){
             // this.$message.success(res.data)

            }else {
              // this.forme.name = ''
              this.$message.error(res.errorMsg)
            }

          })
        }



      },

      handleSelectChange(value) {
        // 判断value是否在options中，如果在，则是手动改变选项 产品类型
        if (this.applyType1Options.find(o => o.id === value)) { //手动改变了选项
          this.forme.applyType2 = ''
        } else { // 进行了赋值操作

        }

        this.$set(this.forme,'applyType1',value)
        this.$forceUpdate()
      },

      handleSelectChange2(value) {
        // 判断value是否在options中，如果在，则是手动改变选项 产品类型
        if (this.applyType2Options.find(o => o.id === value)) {  // 手动改变了选项
          this.forme.applyType2 = ''
        } else { //进行了赋值操作

        }

        this.$set(this.forme,'applyType2',value)
        this.$forceUpdate()
      },




      //上传文件
      handleChangeFile(url,name,file,type){
        let obj =    this.uploadFile(file.file,type)

        obj.then(res=>{
          this.forme[url] = res.filePath
          this.forme[name] = res.fileName
        })

        this.$refs[name].clearFiles(); // 清缓存

      },


      //zip文件校验
      beforeUploadZip(file){
        this.$refs.fileUploadBtn.clearFiles(); // 清缓存
        const isZip = file.type === 'application/x-zip-compressed';
        const isLt20M = (file.size / 1024) /1024 < 20;
        if (!isZip || !isLt20M ){
          if (!isZip) {
            this.$message.error('上传文件只能是ZIP格式!');
            return false
          }
          if (!isLt20M) {
            this.$message.error('上传文件大小不能超过20M!');
            return false
          }

        }else {
          return true
        }
      },



        //pdf文件校验
        beforeUploadPDF(file) {

          const isPdf = file.type === 'application/pdf';
          const isLt20M = (file.size / 1024) /1024 < 20;
          if (!isPdf || !isLt20M ){
            if (!isPdf) {
              this.$message.error('上传文件只能是PDF格式!');
              return false
            }
            if (!isLt20M) {
              this.$message.error('上传文件大小不能超过20M!');
              return false
            }

          }else {
            return true
          }
        },


    //图片文件校验
    beforeUploadIMG(file) {
        const isIMG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg';
      const isLt20M = (file.size / 1024) /1024 < 20;
      if (!isIMG || !isLt20M ){
        if (!isIMG) {
          this.$message.error('上传文件只能是图片格式!');
          return false
        }
        if (!isLt20M) {
          this.$message.error('上传文件大小不能超过20M!');
          return false
        }

      }else {
        return true
      }
    },
    //doc文件校验
    beforeUploadDOC(file) {
      console.log(file,666)
        const isDOC = file.type === 'application/msword' || file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'  || file.type === 'application/wps-office.docx';
        const isLt20M = (file.size / 1024) /1024 < 20;
      if (!isDOC || !isLt20M ){
        if (!isDOC) {
          this.$message.error('上传文件只能是doc格式!');
          return false
        }
        if (!isLt20M) {
          this.$message.error('上传文件大小不能超过20M!');
          return false
        }

      }else {
        return true
      }
    },

    handleRemove(file, fileList) {
      // console.log(file, fileList);
    },
    handlePreview(file) {
      // console.log(file);
    },
    beforeRemove(file, fileList) {
      // return this.$confirm(`确定移除 ${ file.name }？`);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`每次只能上传1个文件，如需重新上传，请先删除上次上传的文件。`);
    },

    handleUpload(file){
      let param = new FormData()
      param.append('file',file.file)
      param.append('type',2)
      uploadSupervisionFile(param).then(res=>{
        if (res.success){
            this.forme.url = res.data.filePath
            this.forme.fileName = res.data.fileName
        }else{
          this.$notify({
            title: '导入失败',
            message: res.errorMsg,
            type: 'error',
            duration: 0
          })
        }
      })
    },

    toDelete(uid){
      const index = this.fileLists.findIndex(item => item.uid === uid);
      if (index !== -1) {
        this.fileLists.splice(index, 1);
      }
      // fileLists


    },
      //前往草稿箱
      toDrafts(path){ //
        this.$router.push({path:path})
      },
      //去评价
      toPj(){
        let params = {
          userId: this.userInfo.rzUserid,
          userName: this.userInfo.organisationName,
          userPhone: this.userInfo.organisationPhone,
          certno: this.userInfo.account,
        }

        pJsubmit(params).then(res=>{
          if (res.errorCode == 200){
            this.pjSrc = res.data
            this.pjSrcIsshow = true
          }

        })

      },
      //详情
      toDetails(){
        this.$router.push({path:'/details',query:{applyId:this.applyIds}})
      },
    saveTemp(formName){
       this.forme.applyUserId = localStorage.getItem('UserId')
        this.$refs[formName].validate((valid)=>{
            if (valid){
              this.forme.applyTypeId = this.forme.applyType3 ? this.forme.applyType3 :( this.forme.applyType2 ? this.forme.applyType2 :this.forme.applyType1 )


              if(!this.isDraft){  //
                this.forme.version = -1
                this.forme.state = 'Editor'


              }

                saveDrafts(this.forme).then(res=>{
                    if (res.success){
                      this.active = 6
                      this.isShow = 'saveTemp'
                        this.$notify({
                            title: '成功',
                            message: '保存成功',
                            type: 'success',
                            duration: 2000
                        })

                    }else{
                        this.$notify({
                            title: '失败',
                            message: res.errorMsg,
                            type: 'error',
                            duration: 0
                        })
                    }
                })
            }

        })



    },
    save(formName){
        this.forme.applyUserId = localStorage.getItem('UserId')

        this.$refs[formName].validate((valid)=>{
            if (valid){
              this.forme.applyTypeId = this.forme.applyType3 ? this.forme.applyType3 :( this.forme.applyType2 ? this.forme.applyType2 :this.forme.applyType1 )

              if(!this.isDraft){  //
                this.forme.version = -1
                this.forme.state = 'Editor'
              }
                submitApplication(this.forme).then(res=>{
                    if (res.success){
                      this.applicationId = res.data.applicationNumber
                      this.applyIds =res.data.applyId
                      this.active = 6
                      this.isShow = 'save'
                      this.$message.success('提交成功')
                      this.toPj()



                    }else{
                      this.$message.error(res.errorMsg)

                    }
                })
            }

        })

    },
    toApply(){

      this.forme ={

          fileList:[],
          applyTypeId:'',
            name:'', //产品中文名称
            namePinyin:'', //拼音名
            nameEnglish:'',//英文名（非必填）
            applyType1:'',//产品类型
            applyType2:'',//产品类型二级
            applyType3:'',//产品类型三级
            otherApplyType:'',//其他产品类型（当产品类型为“其他”时，必填）
            originRange:'',//县级以上人民政府建议的地理标志产品保护范围
            description:'',//产品描述

            applyName:'',
            applyAddress:'',
            applyContacts:'',
            applyPhone:'',
            applyFax:'',
            applyEmail:'',
            originName:'',
            originAddress:'',
            originContacts:'',
            originPhone:'',
            originFax:'',
            originEmail:'',

            historical:'',
            productSell:'',
            popularity:'',

            sensoryCharacter:'',
            pcIndexes:'',


            isTrademark:0,
            trademarkType:'',

            isAgricultural:0,

            fileQualification:'',//申报机构资质证明 当地县级以上人民政府关于成立申报机构或指定协会、企业作为申请人的文件
            fileQualificationUrl:'',//申报机构资质证明文件地址

            fileNameHistorical:'',//产品名称历史渊源
            fileNameHistoricalUrl:'',//产品名称历史渊源明材料地址

            fileProfile:'',//产品知名度
            fileProfileUrl:'',//产品知名度证明材料地址

            fileAddress:'',//县级以上人民政府界定保护范围的建议的文件
            fileAddressUrl:'',

            fileApply:'',//地理标志产品保护申请书
            fileApplyUrl:'',//

            fileApplyProtection:'',//县级以上人民政府申请保护文件：
            fileApplyProtectionUrl:'',

            otherCategories:'',//产品图片
            otherCategoriesUrl:'',

            fileTestReport:'',//产品检测报告
            fileTestReportUrl:'',//

            fileTrademark:'',//商标申明文件或法律文件
            fileTrademarkUrl:'',

            fileTrademarkCard:'',//商标注册证
            fileTrademarkCardUrl:'',

            fileProductProtection:'',//产品保护要求（DOC）
            fileProductProtectionUrl:'',


            fileProductSell:'',//产品生产销售及有关情况
            fileProductSellUrl:'',

            fileOther:'',//其他证明材料(非必填)
            fileOtherUrl:'',


            fileAgricultural:'',//农产品地理标志质量控制技术规范
            fileAgriculturalUrl:'',//



            applyType:'',//产品类型内容
            state:'',

            standardDTOs:[],//现行专有标准或技术规范

            applyUserId:'',

            fileAgriculturalCard:'', //农产品地理标志注册证
            fileAgriculturalCardUrl:'',

        }

        this.active =0



    }



},






}
</script>

<style lang="less" scoped>

.prism-player{
  width: 100%;
  height: 40rem;
}
.step-btn {
    //居中
    display: flex;
    justify-content: center;
    margin-top: 20px;
}

.el-step__title {
    font-size: 16px;
}

.el-step__description {
    font-size: 16px;
}

.el-step__icon {
    font-size: 20px;
}

.step_page{
    margin-top: 2rem;
    // padding-top: 10rem;

}
.step_page_des{
    margin: 1rem 0;
}
.divider{
    margin-top: 2rem;
    margin-bottom: 2rem;
    border-top: 1px solid #ccc;
}
.step_note{
    color: grey;
    font-size: 0.8rem;
    margin-bottom: 0rem;
    text-align: left;
}
.upload-container {
  display: flex;
  align-items: center;

}

</style>



// WEBPACK FOOTER //
// src/landmark-user/views/landmarkApplication/index.vue